import React, { Component, Fragment } from "react";

import * as actions from "../../actions";
import { connect } from "react-redux";

import DocumentMeta from "react-document-meta";
// Component imports
import ContentHeader from "../layout/ContentHeader";
import ServiceInfo from "../ServiceInfo";
import Error from "../Error";

import PanelWrapper from "../layout/PanelWrapper";
import Loader from "../Loader";

import he from "he";

class ServicesContent extends Component {
  componentDidMount(prevProps) {
    window.scrollTo(0, 0);

    if (!this.props.content.loaded) {
      this.props.loadServicesContent();
    }
  }

  render() {
    const meta = {
      title: "Services - Arthur Perfect Job",
      description:
        "Services offered by Arthur Perfect Job. Plumbing, Demolition, Carpentry / Joinery, Electrics, Plastering / Rendering, Flooring, Drylining, Painting and Decorating, Suspended Ceilings, Handyman Service, Partition walls, Tiling.",
      meta: {
        charset: "utf-8",
        name: {
          keywords:
            "plumbing,demolition,carpentry,joinery,electrics,plastering,rendering,flooring,drylining,painting,decorating,suspended,ceilings,handyman,service,partition,walls,tiling.",
          "og:title": "Services - Arthur Perfect Job",
          "og:img": "https://apjhomerenovation.co.uk/img/opengraph.jpg",
          "og:type": "website"
        }
      }
    };

    return (
      <Fragment>
        <DocumentMeta {...meta} />
        <ContentHeader
          title="SERVICES"
          description="This page shows the different services offered by Arthur Perfect Job"
        />

        {this.props.content.error ? <Error /> : null}

        {!this.props.content.loaded && !this.props.content.error ? (
          <PanelWrapper>
            <Loader color="#00ff00" />
          </PanelWrapper>
        ) : (
          this.props.content.services.map(value => (
            <ServiceInfo
              title={value.acf.title}
              tags={value.acf.tags}
              description={he.decode(value.acf.description)}
              image1={value.acf.image_1.url}
              image2={value.acf.image_2.url}
              image3={value.acf.image_3.url}
              key={value.id}
            />
          ))
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { content: state.services };
}

export default connect(
  mapStateToProps,
  actions
)(ServicesContent);



// WEBPACK FOOTER //
// ./src/components/pages/ServicesContent.js